import type { Dispatch } from "@reduxjs/toolkit";
import type { AxiosError } from "axios";
import { DEFAULT_ERROR_MESSAGE } from "data/error-mapping";
import reportsService from "data/services/reports-service";
import toast from "react-hot-toast";
import { actions } from "../reducers/reports.reducer";

export const getAllReports = (params: {
  page: number;
  perpage: number;
  q?: string;
}) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(actions.getAllReportsBegin());
      const res = await reportsService.getAllReports(params);
      if (res.status === 200 || 201 || 202) {
        dispatch(
          actions.getAllReportsSuccess({
            data: res.data.data,
            pagination: res.data.pagination,
          })
        );
      }
    } catch (err: any) {
      const error = err as AxiosError<{ message: string }>;
      const msg = error.response?.data?.message || DEFAULT_ERROR_MESSAGE;
      dispatch(actions.error());
      toast.error(msg);
    }
  };
};
